import { Checkbox } from "@carbon/react";


export const View = ({ rightcontent,leftcontent}) => {
  return (
    <>
    <div className="parentdiv">
        <div className="checkout-payment-content">
            <div className="right-content">
              {rightcontent}
            </div >
            {/*<Checkbox/>*/}
              <input type="checkbox" className="checkout-payment-checkbox"/>
            <div className="left-content" >
              {leftcontent}
            </div>  
        </div>
        </div>
    </>
  );
};
